import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getAuthenticatedAxios } from "./use-authenticated-axios"
import type { UpdatePreferencesParams } from "src/internal-types"

export const useUpdatePreferences = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (params: UpdatePreferencesParams) => {
      const axios = getAuthenticatedAxios()
      const { data } = await axios.patch(
        "/internal/users/update_preferences",
        params
      )
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries()
    },
  })
}
